import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../utils/axiosInstance"; // Adjust path as needed

const useFetchAssetData = (
  endpoint: string,
  queryKey: string,
  queryParams?: string,
  enabledParams : (string | undefined | null)[] = []
) => {
  const fetchData = async () => {
    const url = queryParams ? `${endpoint}?${queryParams}` : endpoint;
    const response = await axiosInstance.get(url);
    return response.data;
  };
  return useQuery({
    queryKey: [queryKey],
    queryFn: fetchData,
    enabled: enabledParams.every((param) => !!param),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: Infinity, // Always fetch new data

  });
};

export default useFetchAssetData;
